import React, { useState, useEffect } from 'react';
import { Box, Card, Typography, Breadcrumbs, Divider, Button } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import { Formik, Form } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { useResponseHandler } from 'hooks/useResponseHandler';
import formInitialValues from './formik/formInitialValues';
import validationSchema from './formik/validationSchema';
import agentsFormModel from './formik/agentsFormModel';
import { AgentesForm } from './components/forms/AgentesForm';
import { saveAgentStore, getDataFormDropDownStore } from 'store/agentes/thunks';
import { MessagesDrawerRight } from 'components/MessagesDrawerRight';
import { agentsMapper } from './mappers/agents.mapper';

export const CreateAgentes = () => {
    const dispatch:any = useDispatch();
    const navigate = useNavigate();
    const { handleResponse, ResponseComponents } = useResponseHandler();
    const { formId, formField } = agentsFormModel;
    const [data, setMsgErrors] = useState([]);

    const { form_options } = useSelector((state: any) => state.agentes);

    useEffect(() => {
        getDataForm();
    }, []); 

    const getDataForm = async()=>{
        await dispatch(getDataFormDropDownStore());
    }

    const servicesOptions = form_options?.services || [];

    const handleSubmit = async (values: any, actions: any) => {
        actions.setSubmitting(true);
        const dto = agentsMapper.toDto(values);
        const response = await dispatch(saveAgentStore(dto));
        
        await handleResponse(response, 'Agente Creado Con Éxito', true);
        actions.setSubmitting(false);

        
    };

    return (
        <Box sx={{ width: '100%' }}>
            <MessagesDrawerRight data={data} title={''} />
            {ResponseComponents}

            <Typography fontSize={25} color="textPrimary" sx={{ fontWeight: 700 }}>Crear Agente</Typography>
            <Breadcrumbs aria-label="breadcrumb" sx={{ padding: 2 }}>
                <Typography color="textPrimary" sx={{ fontWeight: 700 }}>Inteligencia Artificial</Typography>
                <Link color="inherit" to="/manager/plataforma-ia/agentes">
                    Listar Agentes
                </Link>
                <Typography color="textPrimary">Crear Agente</Typography>
            </Breadcrumbs>
            
            <Divider sx={{ marginBottom: 3 }}/>

            <Formik
                initialValues={formInitialValues}
                validationSchema={validationSchema[0]}
                onSubmit={handleSubmit}
            >
                {({ isSubmitting }) => (
                    <Card sx={{ 
                        mt: 2, 
                        p: 3, 
                        borderRadius: 3, 
                        boxShadow: '0px 12px 24px -4px rgba(107, 76, 255, 0.15)',
                        background: (theme) => `linear-gradient(145deg, ${theme.palette.background.paper} 0%, ${theme.palette.primary.light}08 100%)`,
                        border: 'none'
                    }}>
                        <Form id={formId} autoComplete="off">
                            <AgentesForm formField={formField} servicesOptions={servicesOptions} />

                            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 4, gap: 2 }}>
                                <Button 
                                    component={Link}
                                    to="/manager/plataforma-ia/agentes"
                                    color="inherit" 
                                    sx={{ borderRadius: 2, textTransform: 'none' }}
                                >
                                    Cancelar
                                </Button>
                                <Button 
                                    type="submit" 
                                    variant="contained" 
                                    disabled={isSubmitting}
                                    sx={{ 
                                        borderRadius: 2, 
                                        textTransform: 'none',
                                        px: 3,
                                        fontWeight: 600,
                                        background: 'linear-gradient(45deg, #6b4cff 30%, #a855f7 90%)',
                                        boxShadow: '0 4px 14px 0 rgba(107, 76, 255, 0.39)',
                                        '&:hover': {
                                            background: 'linear-gradient(45deg, #583be8 30%, #933ce6 90%)',
                                        }
                                    }}
                                >
                                    Crear Agente
                                </Button>
                            </Box>
                        </Form>
                    </Card>
                )}
            </Formik>
        </Box>
    );
};
